var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0284 18.9239V35.7733C45.0284 36.1883 44.8063 36.548 44.4176 36.7417L27.9251 44.9589C27.2032 45.3186 26.3702 44.7929 26.3702 43.9905V28.1371C26.3702 27.5008 26.1203 26.8921 25.6761 26.4494L18.9014 19.6986C18.2072 19.0069 17.0688 19.5049 17.0688 20.4733V72.5433C17.0688 73.1243 17.5409 73.6223 18.1517 73.6223H53.2192C53.8578 73.6223 54.4408 73.3733 54.8851 72.9306L72.6826 55.3618C72.877 55.1682 73.0158 54.8915 73.0158 54.5871V18.9239C73.0158 18.3429 72.5438 17.8448 71.9329 17.8448H46.1113C45.5282 17.8448 45.0284 18.3152 45.0284 18.9239ZM26.3702 65.3774V55.6662C26.3702 55.2512 26.5923 54.8915 26.981 54.6978L43.4736 46.4806C44.1955 46.1209 45.0284 46.6466 45.0284 47.449V54.4211C45.0284 54.7808 44.8341 55.1128 44.5564 55.3065L28.0639 66.2628C27.342 66.7331 26.3702 66.2351 26.3702 65.3774Z",
    fill: "#00FFA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.38b9f9f2423c24e773e779f5c1208d3a.svg";
export { ForwardRef as ReactComponent };